/**
 * Returns the required transformations to apply to map a given svg
 * defined as the given root node in order to transform all pathes
 * into a 0 0 500 500 viewbox entry.
 *
 * @param rootNode The <svg /> main node to analyse
 */
export var getTransformFromViewBox = function (rootNode) {
    var translateX = 0;
    var translateY = 0;
    var scaleX = 1;
    var scaleY = 1;
    if (rootNode.hasAttribute('viewBox')) {
        var boxEntries = rootNode.getAttribute('viewBox').split(' ').map(function (entry) { return parseInt(entry); });
        if (boxEntries.length != 4) {
            alert('Weird viewbox format, unable to parse');
        }
        //Fixing viewbox X translation value
        if (boxEntries[0] != 0) {
            translateX = boxEntries[0];
            boxEntries[2] -= translateX;
            boxEntries[0] = 0;
        }
        //Fixing viewbox X scaling value
        if (boxEntries[2] != 500) {
            scaleX = 500 / boxEntries[2];
            boxEntries[2] *= scaleX;
        }
        //Fixing viewbox Y translation value
        if (boxEntries[1] != 0) {
            translateY = boxEntries[1];
            boxEntries[3] -= translateY;
            boxEntries[1] = 0;
        }
        //Fixing viewbox Y scaling value
        if (boxEntries[3] != 500) {
            scaleY = 500 / boxEntries[3];
            boxEntries[3] *= scaleY;
        }
    }
    return {
        tx: translateX,
        ty: translateY,
        sx: scaleX,
        sy: scaleY
    };
};
